import './css/item.css';



import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';

import Products from './Products';

function Item(){
    return(
        <>  

            <section class="page-header">
                <div class="container">
                    <div class="row">
                        <ul>
                            <li><a href="index.html">Mainpage</a></li>
                            <li><i class="fa-solid fa-angle-right"></i></li>
                            <li><a href="category.html">Category</a></li>
                            <li><i class="fa-solid fa-angle-right"></i></li>
                            <li><a href="item.html">Item</a></li>
                        </ul>
                    </div>
                </div>
            </section>




            <section class="item">
                <div class="container">
                    <div class="row">




                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <section class="item-galary">
                                <img src={AnimeShapes2} alt="animeproduct"/>
                            </section>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <section id="1" class="item-info">
                                <h3> مجسمات يابانية 
                                </h3>
                                <h1> مجسم أنمي </h1>
                                <h5><span> الرقم التعريفي</span>	M15163 </h5>
                                <ul>
                                    <li><span><i class="fa-solid fa-database"></i> الكمية المتاحة </span> 561 </li>
                                    <li><span><i class="fa-solid fa-location-dot"></i> الدولة</span> اليابان </li>
                                </ul>

                                <div class="rate">
                                    <span class="number">(46)</span>
                                    <span class="stars"><i class="fa-solid fa-star"></i>5.0</span>
                                </div>

                                <h2 class="price-before"> قبل <span>600</span> </h2>

                                <h2 class="price-after"> بعد <span>450</span></h2>

                                <span class="down-range">20%</span>

                                <p><span> ملاحظة: </span> هذا المنتج مستورد من اليابان </p>

                                <button class="add-product-to-cart"> أضف الى العربة </button>

                                <span class="or"> أو </span>

                                <h4>تواصل معنا  <a href="#">+1 (455) 447-3400</a></h4>
                            </section>
                        </div>
                        



                    </div>

                </div>
                
            </section>




        <Products />



        </>
    )
}

export default Item;